module.exports = __webpack_public_path__ + "img/platinum-1.e14c876d.jpg";